import type { FAQ } from '@bharat-consultancy/shared';

export function buildFaqSchema(faqs: FAQ[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: { '@type': 'Answer', text: faq.answer },
    })),
  };
}

export function buildLocalBusinessSchema(params: {
  name: string;
  address: string;
  phone: string;
  url: string;
  areaServed?: string[];
}) {
  return {
    '@context': 'https://schema.org',
    '@type': 'AccountingService',
    name: params.name,
    address: { '@type': 'PostalAddress', streetAddress: params.address, addressRegion: 'West Bengal', addressCountry: 'IN' },
    telephone: params.phone,
    url: params.url,
    areaServed: params.areaServed?.map((name) => ({ '@type': 'City', name })),
  };
}

export function buildBreadcrumbSchema(items: { name: string; url: string }[]) {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.name,
      item: item.url,
    })),
  };
}
